(function() {
  'use strict';

  var API_KEY = 'a847dc29c5ded41f6d80663f0f968367';
  var API_BASE = 'https://sheet.gstincheck.co.in/check/' + API_KEY + '/';

  function isValidGSTIN(g) {
    if (!g || g.length !== 15) return false;
    return /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(g);
  }

  function isCleanCity(city) {
    if (!city) return false;
    var c = city.trim();
    if (c.length > 30 || c.length < 2) return false;
    if (/\d/.test(c)) return false;
    if (/[,\-\/]/.test(c)) return false;
    return true;
  }

  function saveProfile(gstin, lgnm, city) {
    try { sessionStorage.setItem('tt_b2b_profile', JSON.stringify({ gstin: gstin, company_name: lgnm, city: city, ts: Date.now() })); } catch(e) {} try { localStorage.setItem('tt_b2b_verified', JSON.stringify({ company_name: lgnm, city: city, gstin: gstin, verified_at: new Date().toISOString() })); } catch(e) {}
  }

  function clearProfile() {
    try { sessionStorage.removeItem('tt_b2b_profile'); } catch(e) {} try { localStorage.removeItem('tt_b2b_verified'); } catch(e) {}
  }

  function getProfile() {
    try { var s = sessionStorage.getItem('tt_b2b_profile'); return s ? JSON.parse(s) : null; } catch(e) { return null; }
  }

  // ---- Checkout URL builder ----
  function buildCheckoutUrl(p) {
    var params = [];
    if (p.company_name) params.push('checkout[shipping_address][company]=' + encodeURIComponent(p.company_name));
    if (p.gstin)        params.push('checkout[shipping_address][address2]=' + encodeURIComponent(p.gstin));
    if (isCleanCity(p.city)) params.push('checkout[shipping_address][city]=' + encodeURIComponent(p.city.trim()));
    return params.length ? '/checkout?' + params.join('&') : '/checkout';
  }

  // ---- Patch checkout button ----
  function patchBtn(btn) {
    if (btn._ttPatched) return;
    btn._ttPatched = true;
    btn.addEventListener('click', function(e) {
      var p = getProfile(); if (!p) return;
      var form = btn.closest('form');
      if (form) { e.preventDefault(); form.action = buildCheckoutUrl(p); form.method = 'post'; form.submit(); }
      else { e.preventDefault(); window.location.href = buildCheckoutUrl(p); }
    }, false);
  }

  function scanCheckoutBtns() {
    var btns = document.querySelectorAll('button[name="checkout"], input[name="checkout"], a[href="/checkout"]');
    for (var i = 0; i < btns.length; i++) { patchBtn(btns[i]); }
  }

  // ---- Wire the existing cart-gstin-section widget ----
  function wireGstinWidget() {
    var section = document.getElementById('cart-gstin-section');
    if (!section || section._ttWired) return;
    section._ttWired = true;

    var input     = document.getElementById('cart-gstin');
    var verifyBtn = section.querySelector('.gstin-verify-btn');
    var statusEl  = section.querySelector('.gstin-status');
    var autoFields  = document.getElementById('gstin-auto-cart');
    var companyInput = document.getElementById('gstin-company-cart');

    if (!input || !verifyBtn) return;

    // Clear any stale profile on load — must re-verify
    clearProfile();
    if (autoFields) autoFields.classList.add('hidden');
    if (companyInput) companyInput.value = '';

    function setStatus(msg, type) {
      if (!statusEl) return;
      statusEl.textContent = msg;
      statusEl.className = 'gstin-status' + (type ? ' gstin-' + type : '');
    }

    function doVerify() {
      var gstin = (input.value || '').toUpperCase().replace(/\s/g, '');
      input.value = gstin;
      if (!gstin) { clearProfile(); if (autoFields) autoFields.classList.add('hidden'); return; }
      if (!isValidGSTIN(gstin)) { setStatus('Invalid GSTIN format', 'error'); clearProfile(); return; }
      setStatus('Verifying...', 'loading');
      fetch(API_BASE + gstin)
        .then(function(r) { return r.json(); })
        .then(function(resp) {
          if (!resp || resp.flag === undefined) { setStatus('API error — please retry', 'error'); clearProfile(); return; }
          if (!resp.flag) { setStatus('GSTIN not found or invalid', 'error'); clearProfile(); return; }
          var data = resp.data || {};
          var sts = (data.sts || '').toLowerCase();
          if (sts !== 'active') { setStatus('GSTIN status: ' + (data.sts || 'Unknown'), 'error'); clearProfile(); return; }
          var lgnm = data.lgnm || data.tradeNam || '';
          var city = '';
          if (data.pradr && data.pradr.addr) { city = data.pradr.addr.dst || data.pradr.addr.city || data.pradr.addr.loc || ''; }
          setStatus('\u2713 Verified — Active', 'success');
          if (companyInput) { companyInput.value = lgnm; }
          if (autoFields) { autoFields.classList.remove('hidden'); }
          saveProfile(gstin, lgnm, city);
        })
        .catch(function() { setStatus('Network error — please retry', 'error'); clearProfile(); });
    }

    verifyBtn.addEventListener('click', doVerify);
    input.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); doVerify(); } });

    // Clear profile if user edits the input field
    input.addEventListener('input', function() { clearProfile(); setStatus('', ''); if (autoFields) autoFields.classList.add('hidden'); if (companyInput) companyInput.value = ''; });
  }

  // ---- Init ----
  function init() {
    wireGstinWidget();
    scanCheckoutBtns();
  }

  var _n = 0, _t = setInterval(function() { init(); if (++_n >= 20) clearInterval(_t); }, 250);
  var _obs = new MutationObserver(function() { init(); });
  if (document.body) { _obs.observe(document.body, { childList: true, subtree: true }); }
  else { document.addEventListener('DOMContentLoaded', function() { _obs.observe(document.body, { childList: true, subtree: true }); }); }

})();